import { Popover, PopoverArrow, PopoverBody, PopoverCloseButton, PopoverContent, PopoverTrigger, Portal } from '@chakra-ui/react';
import Calendar from 'react-calendar/dist/cjs/Calendar.js';


export default function SelectDate({ value = new Date(), minDate = null, maxDate = null,onChange = (value) => {}, isOpen = false, onClose = null, children = null, ...props }) {
    return (
        <Popover placement='auto-start' isOpen={isOpen} onClose={onClose}>
            <PopoverTrigger>{children}</PopoverTrigger>
            <Portal>
                <PopoverContent bg='white' boxShadow='0 0 10px rgba(0, 0, 0, 0.1)'>
                    <PopoverArrow />
                    <PopoverCloseButton />
                    <PopoverBody>
                        <Calendar minDate={minDate} maxDate={maxDate} calendarType='gregory' className='react-calendar' onChange={onChange} value={value} />
                    </PopoverBody>
                </PopoverContent>
            </Portal>
        </Popover>
    );
}
